/** Polyfill for AWS SDK (buffer): browser has no `global`, Node does. */
(window as unknown as { global: typeof globalThis }).global = typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : globalThis);

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Log uncaught errors (e.g. "prefix-decrement" SyntaxError) with full stack for debugging
window.addEventListener('error', (event) => {
  console.error('[Global Error]', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack,
  });
  if (event.error?.stack) {
    console.error('[Global Error] Stack:\n', event.error.stack);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Rejection]', {
    reason: event.reason,
    stack: event.reason?.stack,
  });
});

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error('[Bootstrap Error]', err);
  console.error('[Bootstrap Error] Message:', err?.message);
  console.error('[Bootstrap Error] Stack:', err?.stack);
});
